<template>
  <main class="main-content">
    <component :is="NavItem"></component>
    <div class="reports-page">
      <!-- Reports Header -->
      <div class="reports-header">
        <div class="icon-title">
          <div class="reports-icon">
            <i class="icon-document"></i>
          </div>
          <h2>Reports</h2>
        </div>
      </div>

      <!-- Filters Container -->
      <div class="filters-container">
        <div class="filters-row">
          <div class="filter-group">
            <label for="productSelect">Select Product</label>
            <div class="select-wrapper">
              <select id="productSelect" v-model="selectedProduct">
                <option value="elimu">Elimu education plan</option>
                <option value="premium">Premium plan</option>
                <option value="basic">Basic plan</option>
              </select>
              <i class="icon-chevron-down"></i>
            </div>
          </div>

          <div class="date-filter-group">
            <label for="fromDate">Date</label>
            <div class="date-inputs">
              <div class="select-wrapper date-select">
                <select id="fromDate" v-model="fromDate">
                  <option value="2025-01-01">Jan 1, 2025</option>
                  <option value="2025-02-01">Feb 1, 2025</option>
                  <option value="2025-03-01">Mar 1, 2025</option>
                </select>
                <i class="icon-chevron-down"></i>
              </div>
              <span class="date-separator">To</span>
              <div class="select-wrapper date-select">
                <select id="toDate" v-model="toDate">
                  <option value="2025-01-31">Jan 31, 2025</option>
                  <option value="2025-02-28">Feb 28, 2025</option>
                  <option value="2025-03-31">Mar 31, 2025</option>
                </select>
                <i class="icon-chevron-down"></i>
              </div>
            </div>
          </div>

          <div class="filter-group">
            <label for="reportType">Report on</label>
            <div class="select-wrapper">
              <select id="reportType" v-model="reportType" @change="handleReportTypeChange">
                <option value="premium">Premium</option>
                <option value="term">Term/Period</option>
                <option value="sum">Sum assured</option>
                <option value="mode">Mode</option>
                <option value="unit">Unit/Agency</option>
                <option value="agent">Per Agent</option>
              </select>
              <i class="icon-chevron-down"></i>
            </div>
          </div>

          <div class="action-buttons">
            <button class="btn-generate" @click="generateReport">Generate</button>
          </div>
        </div>
      </div>

      <!-- Report Stats -->
      <div class="report-stats-section">
        <div class="section-header">
          <h3>Report stats</h3>
          <div class="view-options">
            <button class="view-option" :class="{ active: currentView === 'chart' }" @click="currentView = 'chart'">
              <i class="icon-chart-pie"></i>
            </button>
            <button class="view-option" :class="{ active: currentView === 'data' }" @click="currentView = 'data'">
              <i class="icon-bars"></i>
            </button>
          </div>
        </div>

        <!-- Chart Container -->
        <div class="charts-container">
          <div class="chart-row">
            <div class="chart-container">
              <div class="chart">
                <div class="chart-placeholder" ref="chart1"></div>
              </div>
              <div class="chart-info">
                <p>Total: {{ chartData.total1 }}</p>
                <div class="chart-legend">
                  <div class="legend-item">
                    <span class="legend-color cancelled"></span>
                    <span class="legend-label">Cancelled requests</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color completed"></span>
                    <span class="legend-label">Completed requests</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="chart-container">
              <div class="chart">
                <div class="chart-placeholder" ref="chart2"></div>
              </div>
              <div class="chart-info">
                <p>Total: {{ chartData.total2 }}</p>
                <div class="chart-legend">
                  <div class="legend-item">
                    <span class="legend-color cancelled"></span>
                    <span class="legend-label">Cancelled requests</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color completed"></span>
                    <span class="legend-label">Completed requests</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="chart-container">
              <div class="chart">
                <div class="chart-placeholder" ref="chart3"></div>
              </div>
              <div class="chart-info">
                <p>Total: {{ chartData.total3 }}</p>
                <div class="chart-legend">
                  <div class="legend-item">
                    <span class="legend-color cancelled"></span>
                    <span class="legend-label">Cancelled requests</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color completed"></span>
                    <span class="legend-label">Completed requests</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color ongoing"></span>
                    <span class="legend-label">Ongoing</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
/* eslint-disable */
import NavItem from '@/admin/components/nav/NavItem.vue';

export default {
  name: 'ReportsPage',
  computed: {
    NavItem() {
      return NavItem;
    }
  },
  data() {
    return {
      selectedProduct: 'elimu',
      fromDate: '2025-01-01',
      toDate: '2025-03-31',
      reportType: 'premium',
      isReportTypeDropdownOpen: false,
      currentView: 'chart',
      chartData: {
        total1: '-----',
        total2: '-----',
        total3: '-----',
        chart1Data: {
          cancelled: 50,
          completed: 50
        },
        chart2Data: {
          cancelled: 45,
          completed: 55
        },
        chart3Data: {
          cancelled: 10,
          completed: 85,
          ongoing: 5
        }
      }
    };
  },
  mounted() {
    this.renderCharts();
  },
  methods: {
    handleReportTypeChange() {
      this.isReportTypeDropdownOpen = false;
    },
    toggleReportTypeDropdown() {
      this.isReportTypeDropdownOpen = !this.isReportTypeDropdownOpen;
    },
    generateReport() {
      this.chartData = {
        total1: '1,245',
        total2: '987',
        total3: '2,345',
        chart1Data: {
          cancelled: 40,
          completed: 60
        },
        chart2Data: {
          cancelled: 30,
          completed: 70
        },
        chart3Data: {
          cancelled: 15,
          completed: 80,
          ongoing: 5
        }
      };

      this.renderCharts();
    },
    renderCharts() {
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.reports-page {
  background-color: #f5f7fa;
  padding: 24px;
  font-family: Arial, sans-serif;
  color: #333;
}

.main-content {
  flex: 1;
  padding: 1.5rem 2rem;
  overflow-y: auto;
  background-color: #f0f2f5;
  left: 16%;
  margin-top: 4%;
  width: 100%;
}

.reports-header {
  margin-bottom: 24px;
}

.icon-title {
  display: flex;
  align-items: center;
}

.reports-icon {
  width: 60px;
  height: 60px;
  background-color: #0047cc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.icon-document {
  color: white;
  font-size: 24px;
}

.icon-document::before {
  content: '📄';
}

.reports-header h2 {
  font-size: 24px;
  font-weight: 500;
  color: #333;
}

.filters-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 24px;
}

.filters-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 20px;
  align-items: end;
}

@media (max-width: 992px) {
  .filters-row {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .filters-row {
    grid-template-columns: 1fr;
  }
}

.filter-group {
  display: flex;
  flex-direction: column;
}

.filter-group label {
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
}

.select-wrapper {
  position: relative;
}

.select-wrapper select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  appearance: none;
  background-color: white;
}

.select-wrapper .icon-chevron-down {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.icon-chevron-down::before {
  content: '▼';
  font-size: 12px;
  color: #6b7280;
}

/* Date filter group */
.date-filter-group {
  display: flex;
  flex-direction: column;
}

.date-inputs {
  display: flex;
  align-items: center;
}

.date-select {
  flex: 1;
}

.date-separator {
  margin: 0 12px;
  color: #6b7280;
}

.report-type-dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
  margin-top: 4px;
}

.dropdown-menu-item {
  padding: 10px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.dropdown-menu-item:hover {
  background-color: #f3f4f6;
}

/* Action buttons */
.action-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.btn-generate {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  background-color: #0047cc;
  border: none;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-generate:hover {
  background-color: #0039a6;
}

/* Report Stats Section */
.report-stats-section {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-header h3 {
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.view-options {
  display: flex;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  overflow: hidden;
}

.view-option {
  background: none;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.view-option.active {
  background-color: #f3f4f6;
}

.icon-chart-pie::before {
  content: '📊';
}

.icon-bars::before {
  content: '📈';
}

.charts-container {
  overflow-x: auto;
}

.chart-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  min-width: 800px;
}

.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chart {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.chart-placeholder {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: conic-gradient(
    #E41518 0% 30%,
    #164194 30% 100%
  );
}

.chart-info {
  text-align: center;
}

.chart-info p {
  font-size: 14px;
  margin-bottom: 8px;
}

.chart-legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  white-space: nowrap;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 8px;
}

.legend-color.cancelled {
  background-color: red;
}

.legend-color.completed {
  background-color: green;
}

.legend-color.ongoing {
  background-color: #d1d5db;
}
</style>
